import type { OrganizationScope } from "@/types/organization-scope"

const SHOP_SCOPE_PATTERN = /^(shop|chain-store)-\d+$/
const REGION_SCOPE_PATTERN = /^chain-region-\d+$/
const PLACEHOLDER_DESC_PATTERN = /预留|保留入口|后续版本|当前版本先/

export function isOrganizationScopeSwitchable(scope: OrganizationScope): boolean {
  if (!scope.enabled) {
    return false
  }
  if (scope.type === "chain-headquarter") {
    return scope.meta?.brandId != null
  }
  if (scope.type === "chain-region") {
    return scope.meta?.brandId != null && (scope.meta?.regionId != null || REGION_SCOPE_PATTERN.test(scope.id))
  }
  return scope.meta?.shopId != null || SHOP_SCOPE_PATTERN.test(scope.id)
}

export function getOrganizationScopeStateText(scope: OrganizationScope): string {
  if (isOrganizationScopeSwitchable(scope)) return "进入"
  if (scope.type === "chain-headquarter") return "无总部权限"
  if (scope.type === "chain-region") return "无区域权限"
  return "不可用"
}

export function resolveOrganizationScopeDescription(scope: OrganizationScope): string {
  const desc = scope.desc ?? ""
  if (desc && !PLACEHOLDER_DESC_PATTERN.test(desc)) return desc
  if (scope.type === "chain-headquarter") return "总部统一管理品牌内全部门店，聚合查看经营数据。"
  if (scope.type === "chain-region") return "区域内门店聚合视图，运营数据自动按当前区域裁剪。"
  if (scope.type === "chain-store") return "切换到该分店经营视角，刷新门店数据与权限菜单。"
  return "当前登录门店，业务数据和权限按门店口径读取。"
}
